import { useAzureOwnGroups } from '@internal/plugin-azure-resources-common-react';
import { useMemo } from 'react';

import { groupFilter } from '../azureapi';

export type UserSecurityGroupIds = {
  groupIds: Set<string>;
  loading: boolean;
  error: Error | undefined;
};

export const useUserSecurityGroupIds = (): UserSecurityGroupIds => {
  const { value, loading, error } = useAzureOwnGroups();
  const groupIds = useMemo(
    () =>
      new Set(
        value
          .map(g => ({ id: g.id.toLowerCase(), name: g.displayName ?? '' }))
          .filter(groupFilter)
          .map(g => g.id),
      ),
    [value],
  );
  return { groupIds, loading, error };
};
